import styled from "styled-components";

export const UiUploadFilesModal = styled.div`
	.uploadFileRules {
		display: flex;
		color: rgba(0, 0, 0, 0.45);
		flex-direction: column;
		list-style: disc;

		&,
		ul {
			margin-inline-start: 1.5em;
		}

		ul {
			list-style: circle;
		}
	}

	.ant-modal-body {
		padding: 24px 0;
		max-height: 500px;
		overflow: auto;
	}

	.modalContent {
		display: flex;
		padding: 0 24px;
		flex-direction: column;
		row-gap: 10px;
	}

	.ant-tabs-nav {
		margin: 0 8px 24px;
	}

	.ant-tabs-tab {
		padding: 12px 16px;

		& + .ant-tabs-tab {
			margin-left: 12px;
		}

		&.ant-tabs-tab-active {
			background-color: #dbeeff;

			& .ant-tabs-tab-btn {
				text-shadow: none;
			}
		}
	}
`;
